import { createFormHook, createFormHookContexts } from "@tanstack/react-form";

export const { fieldContext, useFieldContext, formContext, useFormContext } = createFormHookContexts();

// This Wraps the createFormHook with the components and contexts
// it creates a similar object to useForm BUT with the components and contexts already set for easier use on the form
// you can still make custom child implementation when needed for specific fields, but these reusable ones should be the first choice
export const { useAppForm } = createFormHook({
	fieldComponents: {},
	formComponents: {},
	fieldContext,
	formContext,
});
